module.exports = __webpack_public_path__ + "static/media/landscape-white-text.3b3f1950.png";